import request from '@/lib/request';

const api = {};


api.loadingScenario = reqData => request({
  url: 'v1/pcgec/media/ec_basic_server/get_content_type',
  method: 'post',
  data: reqData,
});


api.dataOverview = reqData => request({
  url: '/v3/order/overview/stat/summary',
  method: 'post',
  data: reqData,
});

api.detailsData = reqData => request({
  url: 'v3/order/overview/stat/list',
  method: 'post',
  data: reqData,
});

api.dataExport = reqData => request({
  url: 'v3/order/overview/stat/export',
  method: 'post',
  data: reqData,
});

api.exportOrderStatusQuery = reqData => request({   // v3/settlement_ops/export/status
  url: 'v3/order/stat/export/status',
  method: 'post',
  data: reqData,
  autoErrorTips: false,
});

api.exportStatusQuery = reqData => request({   // v3/settlement_ops/export/status
  url: 'v3/settlement_ops/export/status',
  method: 'post',
  data: reqData,
  autoErrorTips: false,
});


api.orderDetails  = reqData => request({
  url: 'v3/order/stat/list',
  method: 'post',
  data: reqData,
});

api.exportData = reqData => request({
  url: 'v3/order/stat/export',
  method: 'post',
  data: reqData,
});

// 获取saas列表配置
api.getSaasList = reqData => request({
  url: 'v3/order/stat/saasmapping',
  method: 'post',
  data: reqData,
  autoErrorTips: false,
});

export default api;
